import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.TicketTaker;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "TicketTaker.Phaser.IntroductionScene.1",
            "TicketTaker.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/TicketTakerGame/scenes/GameIntro.ts